import { Icon } from 'ant-design-vue'

const IconFont = {
  vm: {},
  // eslint-disable-next-line no-unused-vars
  install (Vue) {
    if (this.installed) {
      return
    }
    this.installed = true

    const IconFont = Icon.createFromIconfontCN({
      scriptUrl: '//iconfont-cdn.eccang.com/t/home-web/iconfont.js'
    })

    // 国旗
    const src = 'https://iconfont-cdn.eccang.com/t/national-flag/iconfont.js'
    const script = document.createElement('script')
    script.setAttribute('src', src)
    script.setAttribute('data-namespace', src)
    document.body.appendChild(script)

    Vue.component('IconFont', IconFont)
  }
}

export default IconFont
